import { useCurrentStream } from '../../feature-player/hooks/player-instance/use-current-stream';

import { useEpisodeOtt } from './use-episode-ott';

export function useVideoToken(contentId: string) {
    const streams = useEpisodeOtt(contentId)?.onlineStreams?.streams;
    const currentStream = useCurrentStream(streams)?.streamMeta?.videoToken;
    return currentStream;
}
